export default {
  type: 'CURRENT_REPORT',
  name: 'CURRENT_REPORT',
  save: { fields: [], key: ['fields', 'that', 'dont', 'exists'] },
  load: { key: 'nodeId' },
  form: { submitLabel: 'Run Report', schema: [] }
}
